import styled, { css } from 'styled-components'
import { mediaQueries } from '../../providers/MediaQueryProvider'

export const Drawer = styled.div`
  position: relative;
  z-index: 10;
`

export const Body = styled.div<{
  $position: 'left' | 'right'
  $width: number | string
}>`
  position: fixed;
  top: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: ${({ $width }) => (typeof $width === 'number' ? `${$width}px` : $width)};
  height: 100%;
  background-color: var(--bg-primary);

  ${({ $position }) =>
    $position === 'left' &&
    css`
      left: 0;
      border-right: 1px solid var(--border-tertiary);
    `}

  ${({ $position }) =>
    $position === 'right' &&
    css`
      right: 0;
      border-left: 1px solid var(--border-tertiary);
    `}
`

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  background-color: var(--color-gray-1200);
  cursor: pointer;
  opacity: 0.6;
`

export const Header = styled.div<{ $size: 'medium' | 'large' }>`
  flex: 0 1 auto;

  border-bottom: 1px solid var(--border-tertiary);

  ${({ $size }) =>
    $size === 'medium' &&
    css`
      padding: var(--space-350) var(--space-400);
    `}

  ${({ $size }) =>
    $size === 'large' &&
    css`
      padding: var(--space-600) var(--space-500);
    `}
`

export const Navigation = styled.div`
  display: flex;
  gap: var(--space-200);
  justify-content: space-between;
`

export const Content = styled.div`
  flex: 1;
  overflow-y: auto;
`

export const Section = styled.div`
  padding: var(--space-500);

  ${mediaQueries.tablet} {
    padding: var(--space-400);
  }
`

export const Footer = styled.div`
  flex: 0 1 auto;
  padding: var(--space-400);
`
